<template>
    <div class="widget-alignment-content-field">
        <div class="w-full mb-3">
            <RedesignFormLabel
                :label="t('widget.innerAlignment')"
                class="mb-2"
            />
            <VcRadioButtonsGroup
                v-model="localContentModel"
                class="radio-groups"
                :radios="alignmentOptions"
                inline
                :config="{
                    labelKey: 'icon',
                    valueKey: 'value',
                    iconKey: 'icon'
                }"
            >
                <template #item="{ option }">
                    <RedesignBaseIcon
                        :name="option.icon"
                        :size="24"
                    />
                </template>
            </VcRadioButtonsGroup>
        </div>

        <div>
            <RedesignFormLabel
                :label="String(t('widget.innerLayout'))"
                class="mb-1"
            />
            <VcRadioGroup
                v-model="localLayoutModel"
                :radios="layoutOptions"
                class="flex items-start justify-start gap-0"
                :config="{
                    labelKey: 'label',
                    valueKey: 'value'
                }"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { VcRadioGroup, VcRadioButtonsGroup } from '@voicenter-team/voicenter-ui-plus'
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { useVModel } from '@vueuse/core'
import {
    COUNTER_CARD_LAYOUT_COLUMNS_VALUE,
    COUNTER_CARD_LAYOUT_DEFAULT_VALUE,
    COUNTER_CARD_LAYOUT_TITLE_ICON_VALUE,
    COUNTER_CARD_LAYOUT_TITLE_VALUE_VALUE
} from '@/enum/default-layout-config'

const { t } = useI18n()

const props = withDefaults(
    defineProps<{
        content: string
        layout: string
        simpleLayoutOptions?: boolean
    }>(),
    {
        content: 'center',
        layout: 'default',
        simpleLayoutOptions: false,
    }
)
const emit = defineEmits<{
    (e: 'update:content', pl: string): void
    (e: 'update:layout', pl: string): void
}>()

const localContentModel = useVModel(props, 'content', emit, { eventName: 'update:content' })
const localLayoutModel = useVModel(props, 'layout', emit, { eventName: 'update:layout' })

const alignmentOptions = [
    {
        value: 'start',
        icon: 'AlignLeft'
    },
    {
        value: 'center',
        icon: 'AlignCenter'
    },
    {
        value: 'end',
        icon: 'AlignRight'
    }
]

const layoutOptions = computed(() => {
    const base = [
        { value: COUNTER_CARD_LAYOUT_DEFAULT_VALUE, label: t('widget.innerLayout.default') },
        { value: COUNTER_CARD_LAYOUT_COLUMNS_VALUE, label: t('widget.innerLayout.columns') },
    ]
    if (props.simpleLayoutOptions) return base

    return [
        ...base,
        { value: COUNTER_CARD_LAYOUT_TITLE_ICON_VALUE, label: t('widget.innerLayout.twoRowsTitle') },
        { value: COUNTER_CARD_LAYOUT_TITLE_VALUE_VALUE, label: t('widget.innerLayout.twoRowsValue') },
    ]
})
</script>
